/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { HomeboundStatusAssessmentViewModel } from './HomeboundStatusAssessmentViewModel'; 

export function getHomeboundStatusOptions(stayId: string, onSuccess?: (result: HomeboundStatusAssessmentViewModel) => void) {
	return queryOptions({
		queryKey: ['homebound-status', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/billing/homeboundstatusassessments/queries/gethomeboundstatus/' + stayId;
			const resp = await axios.get<HomeboundStatusAssessmentViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}